var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "475px",
    height: "196px",
    viewBox: "0 0 475 196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "In-app Illustrations / General / Nothing To Show") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP-Jan",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Non-commercial-03",
    transform: "translate(-483.000000, -421.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ig_NothingToShow",
    transform: "translate(483.000000, 366.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 475,
    height: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 249.5,
    x2: 474,
    y2: 249.5,
    id: "Shape",
    stroke: "#E0E0E0",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,86.18 L347.54,192.72 C347.54,196.188348 344.728348,199 341.26,199 L142.17,199",
    id: "Shape",
    stroke: "#74E5FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.41,199 L133.73,199 C130.265558,198.994483 127.46,196.184447 127.46,192.72 L127.46,61.28 C127.46,57.8155533 130.265558,55.0055166 133.73,55 L341.27,55 C344.734442,55.0055166 347.54,57.8155533 347.54,61.28 L347.54,80",
    id: "Shape",
    stroke: "#738796",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.46,
    y1: 71.4,
    x2: 347.54,
    y2: 71.4,
    id: "Shape",
    stroke: "#738796",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#738796",
    strokeLinecap: "round",
    cx: 137.58,
    cy: 63.59,
    r: 2.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.56,
    y1: 131.86,
    x2: 258.17,
    y2: 131.86,
    id: "Shape",
    stroke: "#738796",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.79,
    y1: 131.86,
    x2: 202.4,
    y2: 131.86,
    id: "Shape",
    stroke: "#738796",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.14,
    y1: 106.7,
    x2: 252.26,
    y2: 117.58,
    id: "Shape",
    stroke: "#738796",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.7,
    y1: 146.14,
    x2: 212.82,
    y2: 157.01,
    id: "Shape",
    stroke: "#738796",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.14,
    y1: 157.01,
    x2: 252.26,
    y2: 146.14,
    id: "Shape",
    stroke: "#738796",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.7,
    y1: 117.58,
    x2: 212.82,
    y2: 106.7,
    id: "Shape",
    stroke: "#738796",
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/emptyBox.0c78ba61264ef35ad74e506990251ed2.svg";
export { ForwardRef as ReactComponent };